import React from 'react';
import SEO from '../components/SEO';
import './StaticPages.css';

function AdChoicesPage() {
  return (
    <main className="static-page">
      <SEO 
        title="Ad Choices - E Media Forum"
        description="Learn about advertising choices and how to manage your ad preferences on E Media Forum."
      />
      
      <div className="page-header">
        <h1>Ad Choices</h1>
        <p className="last-updated">Last Updated: January 2025</p>
      </div>
      
      <div className="page-content">
        <section className="content-section">
          <h2>About Our Advertising</h2>
          <p>
            E Media Forum may display advertisements to help support our free content and services. 
            We work with advertising partners to provide relevant and appropriate advertisements 
            to our users.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Interest-Based Advertising</h2>
          <p>
            We and our advertising partners may use information about your interests to show you 
            more relevant advertisements. This practice is called interest-based advertising.
          </p>
          <p>
            Interest-based ads are based on information about your visits to this and other websites, 
            your geographic location, and other information that does not personally identify you.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Your Advertising Choices</h2>
          <p>You have several options to control the advertisements you see:</p>
          <ul>
            <li>Use browser settings to block or limit cookies</li>
            <li>Opt out of interest-based advertising through industry opt-out tools</li>
            <li>Use ad-blocking software (though this may affect site functionality)</li>
            <li>Adjust your device's advertising preferences</li>
          </ul>
        </section>
        
        <section className="content-section">
          <h2>Third-Party Advertisers</h2>
          <p>
            Third-party advertisers and ad networks may serve advertisements on our website. 
            These companies may use information about your visits to provide advertisements 
            about goods and services that may interest you.
          </p>
          <p>
            We do not control these third-party technologies, and their use is governed by 
            the privacy policies of the companies using such technologies.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Opting Out</h2>
          <p>
            To opt out of interest-based advertising, you can visit the Digital Advertising 
            Alliance's opt-out page or the Network Advertising Initiative's opt-out page.
          </p>
          <p>
            Please note that opting out does not mean you will no longer see advertisements. 
            You will continue to receive generic ads that are not based on your interests.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Contact Information</h2>
          <p>
            If you have questions about our advertising practices, please contact us at 
            info@emediaforum.com
          </p>
        </section>
      </div>
    </main>
  );
}

export default AdChoicesPage;